import React, { useEffect, useState } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentCaptions } from "@fortawesome/pro-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { collection, query, where, getCountFromServer } from "firebase/firestore";
import { db } from "../../../config/firebase";

// Dashboard stat card: count of open CcpBetaFeedback items, click-through to
// the School Feedback admin list (/CcpAdminSchoolFeedback).
const SchoolFeedbackWidget = () => {
  const navigate = useNavigate();
  const [openCount, setOpenCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const loadCount = async () => {
      try {
        const snap = await getCountFromServer(
          query(
            collection(db, "CcpBetaFeedback"),
            where("status", "==", "Open"),
          ),
        );
        if (!cancelled) setOpenCount(snap.data().count);
      } catch (err) {
        console.error("Error loading School Feedback count:", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    loadCount();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Card>
      <CardActionArea onClick={() => navigate("/CcpAdminSchoolFeedback")}>
        <CardContent
          sx={{ display: "flex", alignItems: "center", gap: 2, py: 3 }}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "#a41e36",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <FontAwesomeIcon icon={faCommentCaptions} size="lg" />
          </Box>
          <Box>
            <Typography variant="subtitle1" color="text.secondary">
              School Feedback
            </Typography>
            {loading ? (
              <CircularProgress size={20} />
            ) : (
              <Typography variant="h4" fontWeight="bold">
                {openCount}
              </Typography>
            )}
            <Typography variant="caption" color="text.secondary">
              Open item{openCount === 1 ? "" : "s"}
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default SchoolFeedbackWidget;
